import { useEffect } from "react";
import { Reveal, SectionLabel } from "@/components/Reveal";
import ProjectCard from "@/components/ProjectCard";
import { projects } from "@/data/projects";

const Projects = () => {
  useEffect(() => {
    document.title = "Selected Projects | Stelcore Development";
  }, []);

  return (
    <div data-testid="projects-page">
      <section className="border-b border-ink/10">
        <div className="container-x py-16 md:py-24">
          <Reveal>
            <h1 className="text-4xl sm:text-5xl tracking-tighter font-bold uppercase mt-2 mb-6">
              Our Development Experience
            </h1>
            <p className="text-base text-graphite leading-relaxed max-w-2xl">
              Stelcore Development's credibility is built on real projects. Each project below is
              supported by professional plans of survey prepared by Ontario Land Surveyors — tangible
              documentation of genuine development work in Eastern Ontario.
            </p>
          </Reveal>
        </div>
      </section>
      <section>
        <div className="container-x py-16 md:py-24">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {projects.map((p, i) => (
              <ProjectCard key={p.slug} project={p} index={i} />
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Projects;
